export default "/small-arrow-down.fd2f3b656263b112267ab801f563bece.svg";